<template>
  <div class="workspace" v-if="show">
    <div class="section-heading">
      <h2>Users</h2>
      <a v-if="activeUserInfo.user_group === 4 || activeUserInfo.user_group === 2"><div class="tr-button green-button" @click="addUser = !addUser"><i class="fas fa-plus"></i> Add New User</div></a>
    </div>

    <div v-if="addUser" data-vv-scope="add-user" class="user-edit-cont">
      <h3 style="color:#ff2400;margin-bottom:20px;">*Only Master Admin Can Create New User</h3>
      <div class="user-edit-row">
        <h4>First Name*</h4>
        <input type="text" class="tr-input" v-model="name" name="Name" v-validate="'required'">
        <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
      </div>
      <div class="user-edit-row">
        <h4>Last Name</h4>
        <input type="text" class="tr-input" v-model="last_name" name="Last Name" v-validate="'required'" >
        <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
      </div>
      <div class="user-edit-row">
        <h4>Email*</h4>
        <input type="email" class="tr-input" v-model="email" name="Email" v-validate="'required'" >
        <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
        <span>User will login with this email.</span>
      </div>
      <div class="user-edit-row">
        <h4>Password*</h4>
        <input type="password" class="tr-input"
               data-vv-validate-on="blur"
               v-validate="'required|min:6'"
               name="password"
               v-model="password"/>
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>
        <span>Create a temporary password for this user. Users can change their passwords later.</span>
      </div>
      <div class="user-edit-row">
        <h4>Role</h4>
        <select v-model="user_group">
          <option v-for="(item, index) in user_group_options" v-if="activeUserInfo.user_group !== 2 && activeUserInfo.user_group !== 3 || item.value === 3" :key="index" :value="item.value">{{item.label}}</option>
        </select>
        <div class="role-exp">
          <ul>
            <li v-if="user_group === 2"><strong>Restaurant Owner:</strong> Authorized for order management only.</li>
            <li v-if="user_group === 3"><strong>Editor:</strong> Authorized for editing most key feautures like Orders, Menu, Working Hours, Delivery Zones and Coupons</li>
            <li v-if="user_group === 4"><strong>Admin:</strong> Master Admin. Authorized for everything.</li>
          </ul>
        </div>
      </div>
      <div v-if="user_group === 3 && activeUserInfo.user_group === 4" class="user-edit-row">
        <h4>Restaurants</h4>
        <multiselect name="Restaurants" v-validate="'required'" v-model="selected_restaurants"
                     label="label" track-by="label" :multiple="true"
                     :options="getUserListByGroup(2)">
        </multiselect>
        <span class="text-danger text-sm" v-show="errors.has('Restaurants')">{{ errors.first('Restaurants') }}</span>
      </div>
      <div class="role-exp">
        <p>* Upon creating a new user, this user will be notified with login instructions through email you entered above. They will also see the password you created for them. Once they login they can change these settings by themselves.</p>
      </div>
      <div class="tr-button green-button" @click="submitData">CREATE USER</div>
      <div class="tr-button green-button inactive" @click="addUser = false">CANCEL</div>
    </div>
    <div v-if="editUser"  data-vv-scope="add-user" class="user-edit-cont">
        <div class="section-heading">
          <h2>Account Settings</h2>
        </div>
        <div class="user-edit-row">
          <h4>First Name*</h4>
          <input type="text" class="tr-input" v-model="name" name="Name" v-validate="'required'" >
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
        </div>
        <div class="user-edit-row">
          <h4>Last Name</h4>
          <input type="text" class="tr-input" v-model="last_name" name="Last Name" v-validate="'required'" >
          <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
        </div>
        <div class="user-edit-row">
          <h4>Email*</h4>
          <input type="email" class="tr-input" v-model="email" name="Email" v-validate="'required'" >
          <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
        </div>
        <div class="user-edit-row">
          <h4 v-if="!changePass">Password*</h4>
          <div id="password-change-box" class="password-change-box active" v-if="changePass">
            <div class="user-edit-row">
              <h4>New Password</h4>
              <input type="password" v-model="password" class="tr-input">
            </div>
            <div class="user-edit-row">
              <h4>Confirm New Password</h4>
              <input type="password" v-model="rePassword" class="tr-input">
            </div>
          </div>
          <div @click="changePass = !changePass" class="tr-button blue-button margin-top margin-bottom">{{changePass ? 'Cancel Change' : 'Change Password' }}</div>

        </div>
        <div v-if="user_group === 3 && activeUserInfo.user_group === 4" class="user-edit-row">
          <h4>Restaurants</h4>
          <multiselect name="Restaurants" v-validate="'required'" v-model="selected_restaurants"
                       label="label" track-by="label" :multiple="true"
                       :options="getUserListByGroup(2)">
          </multiselect>
          <span class="text-danger text-sm" v-show="errors.has('Restaurants')">{{ errors.first('Restaurants') }}</span>
        </div>
        <div class="tr-button green-button" @click="saveEditUser">SAVE CHANGES</div>
        <div class="tr-button" @click="deleteUser">Delete User</div>
        <div class="tr-button green-button inactive" @click="editUser = false">CANCEL</div>
    </div>
    <div v-else-if="!addUser && !editUser">
      <div class="user-search-section">
        <div class="user-search-bar">
        <input class="tr-input" type="text" v-model="searchString" placeholder="Search user..."/>
        <span class="text-danger text-sm ml-4" v-show="searchString !== '' && !searchedUsers.length > 0">No result</span>
      </div>
        <div class="user-search-button">
        <div class="tr-button blue-button" @click="searchUsers">Search</div>
      </div>
        <div class="px-5 py-2">
          <input type="checkbox" v-model="sort_by_date" />
          <label class="ml-2">Show Latest On Top</label>
        </div>
      </div>
      <div class="w-full mb-4 flex">

        <div v-if="activeUserInfo.user_group === 4">
          <input type="radio" id="all" name="type-option" v-model="filterData" value="0">
          <label class="pop-radio-label" for="all">All</label>
        </div>

        <div v-if="activeUserInfo.user_group === 4">
          <input type="radio" id="customer" name="type-option" v-model="filterData" value="1">
          <label class="pop-radio-label" for="customer">Customer</label>
        </div>
        <div v-if="activeUserInfo.user_group === 4">
          <input type="radio" id="order-manager" name="type-option" v-model="filterData" value="2">
          <label class="pop-radio-label" for="order-manager">Restaurant Owner</label>
        </div>
        <div>
          <input type="radio" id="editor" name="type-option" v-model="filterData" value="3">
          <label class="pop-radio-label" for="editor">Editor</label>
        </div>
        <div v-if="activeUserInfo.user_group === 4">
          <input type="radio" id="admin" name="type-option" v-model="filterData" value="4">
          <label class="pop-radio-label" for="admin">Admin</label>
        </div>

      </div>
      <div class="user-list-table">
        <div class="user-table-row head">
          <div class="user-table-column">Actions</div>
          <div class="user-table-column">Name</div>
          <div class="user-table-column">Email</div>
          <div class="user-table-column align-right">Role</div>
        </div>
        <div class="user-table-row" v-for="(data, index) in displayList" :key="index">
          <div class="user-table-column"><button @click="handleEditUser(data)">Settings</button></div>
          <div class="user-table-column">{{ data.name }}</div>
          <div class="user-table-column">{{ data.email }}</div>
          <div class="user-table-column align-right">{{ getRole(data.user_group) }}</div>
        </div>

        <div class="pagination flex" v-if="displayListSource.length > itemCount">
          <div @click="pageDown">&laquo;</div>
          <div class="cursor-pointer" @click="pageCount = page - 1" v-for="(page, index) in pageArray" :key="index" :class="page === pageCount + 1 ? 'active' : ''">{{page}}</div>
          <div @click="pageUp">&raquo;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'Users',
  data () {
    return {
      show: false,
      sort_by_date: false,
      pageCount: 0,
      itemCount: 10,
      changePass: false,
      searchString: '',
      selected_restaurants: null,
      searchedUsers: [],
      filterData: '0',
      selectedUserId: 0,
      addUser: false,
      editUser: false,
      user_group: 2,
      user_group_options: [{label: 'Restaurant Owner', value: 2}, {label: 'Editor', value: 3}, {label: 'Admin', value: 4}],
      name: '',
      last_name: '',
      email: '',
      oldEmail: '',
      format: 'yyyy-MM-dd',
      password: '',
      rePassword: '',
      isTermsConditionAccepted: true
    }
  },
  watch: {
    rawlistdata () {
      if (this.rawlistdata.length > 0) {
        this.show = true
      }
    },
    filterData (newVal) {
      this.pageCount = 0
      this.getUserList(newVal)
    },
    user_group () {
    },
    searchString () {
      this.searchUsers()
    },
    editUser () {
      if (!this.editUser) {
        this.clearUserData()
        this.getUserList(this.filterData)
      } else {
        this.getUserList(2)
      }
    },
    addUser () {
      if (this.addUser && this.editUser) {
        this.editUser = false
      }
      if (!this.addUser) {
        this.clearUserData()
        this.getUserList(this.filterData)
      }
      if (this.addUser) {
        this.getUserList(2)
        if (this.activeUserInfo.user_group === 4) {
          this.selected_restaurants = this.getUserListByGroup(2).filter(user => this.activeUserInfo.user_property.restaurants.includes(user.value))
        } else {
          this.selected_restaurants = this.getCurrentRestaurantAsOption()
        }
      }
    },
    sort_by_date () {
      this.$store.commit('api/SET_ORDER_BY', this.sort_by_date)
    }
  },
  computed: {
    order_by_date () {
      return this.$store.state.api.order_by_date
    },
    max_page () {
      const array = JSON.parse(JSON.stringify(this.displayListSource))
      return Math.floor(array.length / this.itemCount)
    },
    pageArray () {
      const array = JSON.parse(JSON.stringify(this.displayListSource))
      const page_array = []
      let i = 0
      const max_page = Math.floor(array.length / this.itemCount)
      const remainder = Math.round(array.length % this.itemCount)
      for (i = 0; i < max_page; i++) {
        page_array.push(parseInt(i) + 1)
      }
      if (remainder > 0) {
        page_array.push(page_array.length + 1)
      }
      return page_array
    },
    activeUserInfo () {
      return this.$store.state.api.currentUser
    },
    rawlistdata () {
      let  data_array = []
      this.userlists.map((list) => {
        data_array = [...data_array, ...list]
      })
      return data_array
    },
    listdata () {
      let  data_array = []
      this.userlists.map((list) => {
        data_array = [...data_array, ...list]
      })
      if (this.filterData !== '0') {
        data_array = data_array.filter((user) => this.filterType(user, Number.parseInt(this.filterData)))
      }

      return data_array
    },
    userlists () {
      return this.$store.state.api.userlists
    },
    displayList () {
      let array = JSON.parse(JSON.stringify(this.displayListSource))
      if (this.sort_by_date) {
        array = array.sort((a, b) => {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.created_date) - new Date(a.created_date)
        })
      }
      return array.splice(this.pageCount * this.itemCount, this.itemCount)
    },
    displayListSource () {
      return this.searchedUsers.length > 0 ? this.searchedUsers : this.listdata
    }
  },
  components: {
    vSelect
  },
  methods: {
    pageUp () {
      if (this.pageCount < this.max_page) {
        this.pageCount += 1
      }
    },
    pageDown () {
      if (this.pageCount !== 0) {
        this.pageCount -= 1
      }
    },
    getCurrentRestaurantAsOption () {
      const users = [this.activeUserInfo]
      const options_array = []
      users.map(user => {
        const option = {
          label: user.user_property['Restaurant-Name'],
          value: user.id
        }
        options_array.push(option)
      })
      return options_array
    },
    getUserListByGroup (group) {
      const users = this.rawlistdata.filter((user) => this.filterType(user, Number.parseInt(group)))
      const options_array = []
      if (this.activeUserInfo.user_group !== 4) {
        users.map(user => {
          if (user.user_property.restaurants.contains(this.activeUserInfo.id)) {
            const option = {
              label: user.user_property['Restaurant-Name'],
              value: user.id
            }
            options_array.push(option)
          }
        })
      } else {
        users.map(user => {
          const option = {
            label: user.user_property['Restaurant-Name'],
            value: user.id
          }
          options_array.push(option)
        })
      }
      return options_array
    },
    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        clickNotClose: true,
        title: 'Confirm',
        acceptText: 'Ok',
        text
      })
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        clickNotClose: true,
        text: 'Are you sure you want to delete this user?',
        accept,
        cancel
      })
    },
    deleteUser () {

      this.openConfirm(() => {
        const obj = {
          user_id: this.selectedUserId
        }
        this.$store.dispatch('api/removeUser', obj).then(() => {
          this.$vs.notify({
            title: 'Delete',
            text: 'Item deleted succesfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.editUser = false
          location.reload()
        }).catch(err => { console.error(err) })
      }, () => {

      })
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          const selected_restaurant_payload = []

          const payload = {
            email: this.email,
            name: this.name,
            last_name: this.last_name,
            password: this.password,
            confirmPassword: this.password,
            user_group: this.user_group,
            active: 1
          }

          if (this.user_group === 3) {
            this.selected_restaurants.map(option => {
              selected_restaurant_payload.push(option.value)
            })
            const property = {
              'restaurants': JSON.stringify(selected_restaurant_payload)
            }
            payload.property = property
          }

          if (this.user_group === 2) {
            const property = {
              'Restaurant-Name': this.email
            }
            payload.property = property
          }

          this.$store.dispatch('api/registerUser', payload).then(() => {
            this.openAlert('Item saved successfully')
            this.addUser = false
            location.reload()
          }).catch(err => {
            console.error(err.message)
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: err.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
        }
      })
    },
    saveEditUser () {
      this.$validator.validateAll().then(result => {
        let passwordResponse = false
        if (this.password !== '') {
          if (this.password !== this.rePassword) {
            this.$vs.notify({
              title: 'Error',
              text: 'Passwords do not match',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
            this.$vs.loading.close()
            passwordResponse = true
          }
        }
        if (result && !passwordResponse) {

          this.$vs.loading()
          let property = {}
          if (this.user_group === 3) {
            const selected_restaurant_payload = []

            this.selected_restaurants.map(option => {
              selected_restaurant_payload.push(option.value)
            })

            property = {
              'restaurants': JSON.stringify(selected_restaurant_payload)
            }
          }

          const payload = {
            user_id: this.selectedUserId,
            name: this.name,
            email: this.email,
            last_name: this.last_name,
            user_group: this.user_group,
            property
          }
          if (this.password !== '') {
            payload.password = this.password
          }

          let dispatch_uri = 'api/updateUserRegular'
          if (this.selectedUserId === this.activeUserInfo.id) {
            dispatch_uri = 'api/updateUserSelf'
          }
          this.$store.dispatch(dispatch_uri, payload).then(() => {
            let message = ''
            /*if (this.oldEmail !== this.email) {
              message = `Click the confirmation link we sent to ${this.email} to change your email`
            } else {
              message = 'Item saved successfully'
            }*/
            message = 'Item saved successfully'
            this.openAlert(message)

            this.getUsers()
            this.editUser = false
            this.$vs.loading.close()
          }).catch(err => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: err.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })

        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Please enter valid details',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }
      })

    },
    clearUserData () {
      this.name = ''
      this.last_name = ''
      this.email = ''
      this.user_group = 2
      this.selected_restaurants = []
    },
    handleEditUser (user) {
      const {id, name, last_name, email, user_group, user_property} = user
      this.name = name
      this.last_name = last_name
      this.email = email
      this.oldEmail = email
      this.user_group = user_group
      this.selectedUserId = id
      this.editUser = true

      const managing_restaurants = user_property['restaurants']
      if (this.activeUserInfo.user_group === 4) {
        this.selected_restaurants = this.getUserListByGroup(2).filter(user => managing_restaurants.includes(user.value))
      } else {
        this.selected_restaurants = this.getCurrentRestaurantAsOption()
      }
    },
    filterUsers (user, query) {
      return user.name.toLowerCase().includes(query.toLowerCase()) || user.email.toLowerCase().includes(query.toLowerCase())
    },
    filterType (user, type) {
      return user.user_group === type
    },
    filterUsersByGroup () {

    },
    searchUsers () {
      this.searchedUsers = this.listdata.filter((user) => this.filterUsers(user, this.searchString))
    },
    getRole (group) {
      if (group === 1) {
        return 'Customer'
      } else if (group === 2) {
        return 'Restaurant Owner'
      } else if (group === 3) {
        return 'Editor'
      } else {
        return 'Admin'
      }
    },
    getUserList (group_id) {
      // Loading

      const payload = {
        user_group: group_id,
        user: this.activeUserInfo
      }

      this.$vs.loading()

      this.$store.dispatch('api/getUsersRaw', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getUsers () {
      this.$store.commit('api/SET_USERS_RAW', null)
      this.getUserList(1)
      this.getUserList(3)
      if (this.activeUserInfo.user_group === 4) {
        this.getUserList(2)
        this.getUserList(4)
      }
    }
  },
  mounted () {
    this.getUsers()
    this.sort_by_date = this.order_by_date
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.align-right {
  text-align: right;
}
</style>
